export const taskReducer = (state = { loading: false, tasks: [], currentTask: null, taskError: null }, action) => {
    switch (action.type) {
        case 'TASKS_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'TASKS_SUCCESS':
            return {
                ...state,
                loading: false,
                tasks: action.payload
            }
        case 'TASKS_ERROR':
            return {
                ...state,
                loading: false,
                taskError: action.payload
            }
        case 'TASK_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                tasks: [...state.tasks, { ...action.payload, groupName: action.payload.groupName || action.payload.group }]
            }
        case 'TASK_SUCCESS':
            return {
                ...state,
                loading: false,
                currentTask: action.payload
            }
        default:
            return state
    }
}
